export default __webpack_public_path__ + "static/media/disc.fa72bdae.jpg";